import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikMove extends ASTBlock {
    constructor(color) {
        super(color, "alvik_move")
        this.predefinedInputs = {
            "distance": {
                "block": {
                    "type": "number",
                    "fields": {
                        "value": 0
                    }
                }
            }
        }
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "type": "BooleanBlock",
            "tooltip": "",
            "helpUrl": "",
            "message0": "fahre %1 für %2 cm %3",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "direction",
                    "options": [
                        [
                            "vorwärts",
                            "+"
                        ],
                        [
                            "rückwärts",
                            "-"
                        ]
                    ]
                },
                {
                    "type": "input_value",
                    "name": "distance",
                    "check": "Number"
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "previousStatement": null,
            "nextStatement": null,
            "inputsInline": true
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}